import { FC, ReactNode } from 'react'
import classnames from 'classnames'

import styles from './wrapper.module.scss'

interface WrapperProps {
  className?: string
  children?: ReactNode
}

const Wrapper: FC<WrapperProps> = ({ children, className }) => (
  <div className={classnames(styles.wrapper, className)}>{children}</div>
)

export default Wrapper
